const buyingAssistantSteps = {
    vehicleSelection: { step_number: 2, step_name: 'vehicle_selection' },
    budgetSelection: { step_number: 3, step_name: 'budget_selection' },
    preferencesSelection: { step_number: 4, step_name: 'preferences_selection' }
} as const;

export const BUYING_ASSISTANT_FUNNELS = {
    car: {
        funnelName: 'car_buying_assistant',
        steps: buyingAssistantSteps
    },
    motor: {
        funnelName: 'moto_buying_assistant',
        steps: buyingAssistantSteps
    }
} as const;

export const VEHICLE_FINES_FUNNEL = {
    funnelName: 'vehicle_fines_payment',
    steps: {
        identityCheck: { step_number: 2, step_name: 'identity_check' },
        plateConfirmed: { step_number: 3, step_name: 'plate_confirmed' },
        inquiryTypeSelection: { step_number: 4, step_name: 'inquiry_type_selection' },
        resultView: { step_number: 6, step_name: 'result_view' },
        paymentMethodSelection: { step_number: 7, step_name: 'payment_method_selection' }
    }
} as const;

export const FREEWAY_TOLLS_FUNNEL = {
    funnelName: 'freeway_tolls_payment',
    steps: {
        identityCheck: { step_number: 2, step_name: 'identity_check' },
        plateConfirmed: { step_number: 3, step_name: 'plate_confirmed' },
        paymentMethodSelection: { step_number: 4, step_name: 'payment_method_selection' }
    }
} as const;

export const TRAFFIC_PLAN_FUNNEL = {
    funnelName: 'traffic_plan_payment',
    steps: {
        paymentMethodSelection: { step_number: 4, step_name: 'payment_method_selection' }
    }
} as const;

const inspectionSteps = {
    vehicleSelection: { step_number: 2, step_name: 'vehicle_selection' },
    serviceTypeSelection: { step_number: 3, step_name: 'service_type_selection' },
    reservation: { step_number: 4, step_name: 'reservation' },
    address: { step_number: 5, step_name: 'address' },
    extraServices: { step_number: 6, step_name: 'extra_services' },
    payment: { step_number: 7, step_name: 'payment' }
} as const;

export const INSPECTION_FUNNELS = {
    car: {
        funnelName: 'car_expert_request',
        businessLine: 'car_expert_request',
        steps: inspectionSteps
    },
    motor: {
        funnelName: 'moto_expert_request',
        businessLine: 'moto_expert_request',
        steps: inspectionSteps
    }
} as const;

export const VEHICLE_FINES_PURCHASE_ITEMS = {
    inquiryFee: {
        item_id: 'INQUIRY_FEE',
        item_name: 'Vehicle Fines Inquiry Fee'
    },
    trafficFine: {
        item_id: 'TRAFFIC_FINE',
        item_name: 'Traffic Fine Payment'
    }
} as const;

export const TRAFFIC_PLAN_PURCHASE_ITEM = {
    item_id: 'TRAFFIC_PLAN',
    item_name: 'Traffic Plan Payment'
} as const;

export const FREEWAY_TOLL_PURCHASE_ITEM = {
    item_id: 'FREEWAY_TOLL',
    item_name: 'Freeway Toll Payment'
} as const;

const batterySteps = {
    vehicleSelection: { step_number: 2, step_name: 'vehicle_selection' },
    batterySelection: { step_number: 3, step_name: 'battery_selection' },
    identityCheck: { step_number: 4, step_name: 'identity_check' },
    reservation: { step_number: 5, step_name: 'reservation' },
    address: { step_number: 6, step_name: 'address' },
    extraServices: { step_number: 7, step_name: 'extra_services' },
    payment: { step_number: 8, step_name: 'payment' }
} as const;

export const BATTERY_FUNNELS = {
    car: {
        funnelName: 'car_battery_purchase',
        businessLine: 'car_battery',
        steps: batterySteps
    },
    motor: {
        funnelName: 'moto_battery_purchase',
        businessLine: 'moto_battery',
        steps: batterySteps
    }
} as const;
